module.exports = __webpack_public_path__ + "img/dsci0001.3f3228ad.jpg";